import globalConfiguration from '@/api/config/globalConfiguration'
import { queryKeys } from '@/constant/common'
import { UpdateGlobalConfiguration } from '@/types/globalConfiguration'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { useConfigUI } from '../../context'
import useTranslation from '@/hooks/useTranslation'

async function updateEtZone(payload: UpdateGlobalConfiguration): Promise<void> {
  await globalConfiguration.update(payload)
}

function useUpdateGlobal() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { closeSidebar } = useConfigUI()

  return useMutation(
    (payload: UpdateGlobalConfiguration) => updateEtZone(payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKeys.globalConfiguration])
        toast.success(t('updateGlobalConfigurationsSuccess'))
        closeSidebar()
      },
      onError: (error: any) => {
        if (error?.statusCode === 400) {
          toast.error(error?.message)
        } else toast.error(t('updateGlobalConfigurationsError'))
      },
    },
  )
}

export default useUpdateGlobal
